<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of curBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="clickHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>
<script>
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  export default {
    name: 'DetailFooterButtons',
    mixins: [IntermodalityCommonMixin],
    props: {
      pageMode: {
        type: Number,
        default: () => 0,
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      contractType: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        mPageMode: 0,
        status: '',
        type: null,
        allBtnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'save',
            params: 0,
            key: 'save',
          },
          {
            title: '编辑',
            type: 'primary',
            clickName: 'edit',
            params: 0,
            key: 'edit',
          },
          {
            title: '补充协议',
            type: 'primary',
            clickName: 'revise',
            params: 0,
            key: 'revise',
          },
          {
            title: '返回',
            type: 'primary',
            clickName: 'view',
            params: 0,
            key: 'view',
          },
          {
            title: '提交',
            type: 'primary',
            clickName: 'save',
            params: 1,
            key: 'submit',
          },
          {
            title: '启用',
            type: 'primary',
            clickName: 'activate',
            params: 1,
            key: 'activate',
          },
          {
            title: '停用',
            type: 'primary',
            clickName: 'deactivate',
            params: 1,
            key: 'deactivate',
          },
          {
            title: '删除',
            type: 'primary',
            clickName: 'delete',
            params: 1,
            key: 'delete',
          },
          {
            title: '保存纸质合同号',
            type: 'primary',
            clickName: 'editContractNo',
            params: 1,
            key: 'editContractNo',
          },
        ],
        curBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      clickHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      buttonStatusChange() {
        // let name = this.$route.name;
        // let isCustomerContract = name == 'customerContractDetail';
        let status = this.getStatusName('contract', this.status);
        // let contractType = this.baseInfoData.contractType;
        let pageMode = this.mPageMode;

        console.log('buttonsStatus', status, pageMode);

        this.curBtnList = this.allBtnList.map((item) => {
          if (pageMode == 0) {
            if (['submit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 1 || pageMode == 2) {
            let list = [
              'save',
              'edit',
              'revise',
              'view',
              'submit',
              'activate',
              'deactivate',
              'delete',
              'editContractNo',
            ];

            if (pageMode == 1) {
              list = list.filter((item) => item != 'save' && item != 'view' && item != 'submit');
            } else {
              list = list.filter((item) => item != 'edit' && item != 'revise');
            }

            if (status != '' && status != '已保存' && status != '已驳回' && status != '已生效') {
              list = list.filter((item) => item != 'submit');
            }

            if (status == '已生效' || status == '修订已驳回') {
              list = list.filter((item) => item != 'edit');
            } else {
              list = list.filter((item) => item != 'revise');
            }

            if (status == '已生效') {
              list = list.filter((item) => item != 'save');
            }

            if (status != '已保存') {
              list = list.filter((item) => item != 'delete');
            }

            if (status != '已停用' && status != '已生效') {
              list = list.filter((item) => item != 'deactivate');
            }

            if (status != '已启用') {
              list = list.filter((item) => item != 'activate');
            }

            if (status != '已生效') {
              list = list.filter((item) => item != 'deactivate');
            }

            if (status == '审批中' || status == '修订审批中') {
              list = [];
            }

            if (status == '已停用') {
              list = ['activate'];
            }

            if (status == '修订已驳回') {
              if (pageMode == 1) {
                list = ['revise'];
              } else {
                list = ['view', 'submit'];
              }
            }

            // 已驳回状态下只能提交，不能保存
            if (status == '已驳回') {
              list = list.filter((item) => item != 'save');
            }

            //结算条款无法补充协议
            if (this.type && this.type == '1') {
              list = list.filter((item) => item != 'revise');
            }

            if (this.$route.query?.btnType == 'editContractNo') {
              list = ['editContractNo'];
            } else {
              list = list.filter((item) => item != 'editContractNo');
            }

            if (list.includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.curBtnList.every((item) => item.disabled);
      },
    },
    mounted() {
      this.buttonStatusChange();
    },
    watch: {
      pageMode: {
        handler(val) {
          this.mPageMode = val;
          this.buttonStatusChange();
        },
        immediate: true,
      },
      contractStatus: {
        handler(nV, oV) {
          if (nV && nV != oV) {
            this.status = nV;
            this.buttonStatusChange();
          }
        },
        immediate: true,
      },
      contractType: {
        handler(nV, oV) {
          if (nV && nV != oV) {
            this.type = nV;
            this.buttonStatusChange();
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
